import React from 'react';
import { NavLink } from 'react-router-dom';
import { Useglobelcontext } from './component/blogcontext/Blogcontext';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { BASE_URL } from './Config/Config';
import 'swiper/css';
import 'swiper/css/navigation';

function Blogarea() {
  const { Blogdata } = Useglobelcontext();
        console.log(Blogdata);
  return (
    <>
      <section className="overflow-hidden space" id="blog-sec">
        <div className="container">
          <div className="mb-35 text-center text-md-start">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-8">
                <div className="title-area mb-md-0">
                  <span className="sub-title">
                    <i className="fal fa-book me-2" /> Our News & Blogs
                  </span>
                  <h2 className="sec-title">Latest News & Blogs</h2>
                </div>
              </div>

              <div className="col-md-auto">
                <NavLink to="/blog" className="th-btn">
                  View All Posts<i className="fa-solid fa-arrow-right ms-2" />
                </NavLink>
              </div>
            </div>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            navigation
            autoplay={{
              delay: 3000, // Autoplay delay (3 seconds)
              disableOnInteraction: false, // Continue autoplay on interaction
            }}
            spaceBetween={20}
            slidesPerView={3}
            loop={true}
            breakpoints={{
              320: { slidesPerView: 1 }, // Small devices
              768: { slidesPerView: 2 }, // Tablets
              1024: { slidesPerView: 3 }, // Laptops
              1200: { slidesPerView: 4 }, // Larger screens
            }}
          >
            {Blogdata.map((curdata, index) => (
              <SwiperSlide key={index}>
                <div className="th-blog blog-single style2">
                  <div className="blog-img">
                    <NavLink to={`/blogdetail/${curdata.slug}` }>
                      <img src={`${BASE_URL}${curdata.image}`} alt="Blog Image" />
                    </NavLink>
                  </div>
                  <div className="blog-content">

                    <div className="blog-meta">
                      <NavLink className="author" to={`/blogdetail/${curdata.slug}`}>
                        <i className="fa-light fa-user" /> {curdata.author_name.author_name}
                      </NavLink>
                      <NavLink to={`/blogdetail/${curdata.slug}`}>
                        <i className="fa-light fa-clock" /> {new Date(curdata.create_date).toLocaleDateString('en-CA')}
                      </NavLink>
                    </div>
                    
                    <h4 className="box-title">
                      <NavLink to={`/blogdetail/${curdata.slug}`}>
                        {curdata.title}
                      </NavLink>
                    </h4>
                    <NavLink
                      to={`/blogdetail/${curdata.slug}`}className="link-btn" >Read More Details<i className="fas fa-arrow-right ms-2" /></NavLink>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Blogarea;
